module.exports = __webpack_public_path__ + "img/63.7f30ae4e.jpg";